<div class="tw-flex-col tw-flex tw-justify-center tw-items-center tw-gap-5 tw-mt-4">
  <i
    class="bwi bwi-2x bwi-spinner bwi-spin tw-text-primary-600"
    title="{{ 'loading' | i18n }}"
    aria-hidden="true"
  ></i>
  <h2 bitTypography="h1">{{ "generatingRiskInsights" | i18n }}</h2>
</div>
